// Graphics mode: 3D (Three.js dioramas & globe) or 2D (canvas — light on slower GPUs/CPUs).
// ?2d in the URL forces 2D for one visit; the player's choice is remembered in localStorage.
const KEY = 'driller.gfx';
const urlForces2D = () => typeof location !== 'undefined' && new URLSearchParams(location.search).has('2d');
function stored() { try { return localStorage.getItem(KEY); } catch { return null; } }

export const FORCE_2D = urlForces2D() || stored() === '2d';
export const graphicsMode = () => (FORCE_2D ? '2d' : '3d');

// Switching renderers needs a fresh page: save first, then reload (dropping a one-off ?2d so the choice sticks).
export function setGraphicsMode(mode, ctx) {
  try { localStorage.setItem(KEY, mode === '2d' ? '2d' : '3d'); } catch {}
  try { ctx?.save?.('auto'); } catch {}
  const url = new URL(location.href);
  url.searchParams.delete('2d');
  url.searchParams.set('play', '');
  location.href = url.toString().replace('play=', 'play');
}
